Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.math?window.GrimoireJS.lib.math.GLM:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-math/ref/GLM.js
// module id = 36
// module chunks = 0